import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import head from 'lodash/head';
import { FormWrapper } from '../../styles/styled';
import { authManager } from '../../helpers/managers';
import { emailValidator } from '../../helpers/validators';
import CustomDialog from '../dashboard/components/custom_dialog';
import SignInForm from './SignInForm';

class FacebookTransition extends Component {
  constructor(props) {
    super(props);

    const { email } = props;
    this.state = {
      email,
      password: '',
      confirmPassword: '',
      loading: false,
      error: '',
    };
  }

  confirmPasswordMatch = () => {
    const { password, confirmPassword } = this.state;
    if (isEmpty(password) || isEmpty(confirmPassword)) {
      return true;
    }

    return isEqual(password, confirmPassword);
  };

  handleInputChange = prop => {
    return e => {
      this.setState({
        [prop]: e.target.value,
        error: '',
      });
    };
  };

  showError = error => {
    this.setState({
      error,
      loading: false,
    });
  };

  updateAccount = async () => {
    const { email, password = '', confirmPassword = '' } = this.state;
    const { onTransitionSuccess } = this.props;

    if (!emailValidator(email)) {
      return this.showError('Please enter a valid email address');
    }

    if (password.length < 6 || isEmpty(password)) {
      return this.showError('Please enter a valid password');
    }

    if (isEmpty(confirmPassword)) {
      throw this.showError('Plase confirm your password');
    }

    if (!this.confirmPasswordMatch()) {
      throw this.showError('Please make sure you enter the same password twice.');
    }

    this.setState({ loading: true });
    const user = authManager.getCurrentUser();
    if (isEmpty(user)) {
      return this.showError('No user account to transition, please login to continue');
    }

    // get old providerId
    const { providerData } = user;
    const { providerId } = head(providerData);

    try {
      // the new credential
      const credential = authManager.getEmailCredential(email, password);

      // link the new credential
      const usercred = await user.linkWithCredential(credential);
      console.log('Account linking success', usercred);

      // from here, unlink the old credential
      await user.unlink(providerId);
      console.log('Account unlinking success', providerId);

      // show alert box
      this.alertDialog.showModal({
        content: 'Your account has been successfully updated.',
        onClose: () => onTransitionSuccess(user),
      });
    } catch (error) {
      this.showError(`Transition error: ${error.message}`);
    }
  };

  render() {
    const { firstName, lastName, email, password, confirmPassword, loading, error } = this.state;

    return (
      <Form>
        <div className="row">
          <div className="col-lg-12 center-col text-center">
            <h1 className="title-large margin-five">Update Account</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="text-medium transition-info">
              We're transitioning all of our users to email/password authentication, please create a
              password for your account. Rest assured that your current data is intact and secured.
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <SignInForm
              withHeader={false}
              email={email}
              password={password}
              confirmPassword={confirmPassword}
              withConfirmPassword={true}
              onInputChange={this.handleInputChange}
              onSignIn={this.updateAccount}
              error={error}
              processing={loading}
              submitBtnLabel="UPDATE"
              withForgetPass={false}
            />
          </div>
        </div>
        <CustomDialog
          ref={ref => (this.alertDialog = ref)}
          contentStyle={{
            maxWidth: 580,
          }}
        />
      </Form>
    );
  }
}

const Form = styled(FormWrapper)`
  padding: 40px 0 0;

  .transition-info {
    padding: 0 40px;
  }
`;

PropTypes.defaultProps = {
  email: PropTypes.string,
  onTransitionSuccess: PropTypes.func,
};

PropTypes.defaultProps = {
  email: '',
  onTransitionSuccess: () => {},
};

export default FacebookTransition;
